<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <v-form v-model="tudoValido">
      <v-row align="center" class="px-12">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title>| Relatório de Entradas</v-toolbar-title>
          </v-toolbar>
        </v-col>

        <v-col cols="12">
          <v-autocomplete v-model="filtrosRelatorio.numerosItensSistema" :items="listaDeProdutos" :loading="!listaDeProdutos" :readonly="!listaDeProdutos" chips multiple clearable label="Lista de Produtos" autocomplete="off" prepend-icon="mdi-file-table">
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeItem(data.item)">
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete v-model="filtrosRelatorio.indicadorStatusFamilia" :items="listaDeFamilias" :loading="!listaDeFamilias" :readonly="!listaDeFamilias" chips multiple clearable label="Famílias de Produtos" autocomplete="off" prepend-icon="mdi-format-list-bulleted-type">
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeStatus(data.item)">
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row align="center" class="px-12 pb-12">
        <v-col cols="12" lg="6">
          <v-menu v-model="menuDe" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="filtrosRelatorio.dataInicioFormatada"
                label="De:"
                hint="DD/MM/AAAA"
                persistent-hint
                prepend-icon="mdi-calendar-today"
                autocomplete="off"
                v-mask="['##/##/####']"
                @blur="filtrosRelatorio.dataInicio = analizarData(filtrosRelatorio.dataInicioFormatada)"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filtrosRelatorio.dataInicio" no-title @input="menuDe = false" @change="filtrosRelatorio.dataInicioFormatada = formatarData(filtrosRelatorio.dataInicio)"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" lg="6">
          <v-menu v-model="menuAte" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
            <template v-slot:activator="{ on }">
              <v-text-field 
                v-on="on" 
                v-model="filtrosRelatorio.dataFimFormatada" 
                label="Até" 
                hint="DD/MM/AAAA" 
                persistent-hint 
                prepend-icon="mdi-calendar" 
                autocomplete="off" 
                v-mask="['##/##/####']" 
                @blur="filtrosRelatorio.dataFim = analizarData(filtrosRelatorio.dataFimFormatada)"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filtrosRelatorio.dataFim" no-title @input="menuAte = false" @change="filtrosRelatorio.dataFimFormatada = formatarData(filtrosRelatorio.dataFim)"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" align="center">
          <v-btn :disabled="botaoGerarRelatorio" width="300" color="green" class="white--text" @click="gerarRelatorio">
            GERAR RELATÓRIO
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <Loading :open="loading" />

    <FormRelatorio :isTheModalOpen="formRelatorio.isOpen" :modalTitleToolbar="formRelatorio.modalTitleToolbar" v-on:fecharModal="fecharFormRelatorio" v-on:generate-excel="gerarExcel(formRelatorio.dataRelatorio)">
      <!-- #region TODOS ITENS RECEBIDOS -->
      <v-row class="px-4 pt-4 pb-2">
        <v-col cols="12">
          <v-card>
            <v-card-title>• Todos produtos recebidos</v-card-title>

            <v-row class="px-6 pb-6">
              <v-col v-if="formRelatorio.dataRelatorio.entradaGeralItens.length > 0" cols="12">
                <DataTable :tableTitle="'Total recebido: ' + formRelatorio.dataRelatorio.quantidadeTotalEntrada" :tableHeader="headerTodosItensRecebidos" :tableRows="formRelatorio.dataRelatorio.entradaGeralItens"></DataTable>
              </v-col>

              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de exibir todos os produtos recebidos, pois, não há dados para exibir.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-- #endregion -->

      <!-- #region DADOS ENTRADAS -->
      <v-row class="px-4 pt-2 pb-4">
        <v-col cols="12">
          <v-card>
            <v-card-title v-if="formRelatorio.dataRelatorio.dataInicio">• Notas recebidas de {{ formRelatorio.dataRelatorio.dataInicio }} até {{ formRelatorio.dataRelatorio.dataFim }}</v-card-title>
            <v-card-title v-else>• Notas recebidas</v-card-title>

            <v-row>
              <v-col v-if="formRelatorio.dataRelatorio.entradasUnidade.length > 0" cols="12">
                <v-list>
                  <v-list-group v-for="(entradaSelecionada, i) in formRelatorio.dataRelatorio.entradasUnidade" :key="i" no-action sub-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div>
                            Nota: N° <b>{{ entradaSelecionada.dispensa.numeroDispensa }}</b> - <b>{{ entradaSelecionada.historicoEntradaItem.descricaoNumeroNota }}</b>
                          </div>
                          <div>
                            Data entrada: <b>{{ formatarDataBancoTipoPadrao(entradaSelecionada.dispensa.dataDispensa) }}</b>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item>
                      <v-list-item-content class="px-2">
                        <v-card class="px-4 py-6">
                          <v-card-title>Nota: N° {{ entradaSelecionada.dispensa.numeroDispensa }} - {{ entradaSelecionada.historicoEntradaItem.descricaoNumeroNota }} | Total: {{ entradaSelecionada.dispensa.quantidadeDispensa }}</v-card-title>

                          <v-card-text>
                            <v-row>
                              <v-col cols="6" class="py-2">
                                <div class="tituloInfo">Número nota</div>

                                <div :class="entradaSelecionada.historicoEntradaItem.descricaoNumeroNota ? 'descricaoInfo' : 'textoVazio'">
                                  {{ formataVazio(entradaSelecionada.historicoEntradaItem.descricaoNumeroNota) }}
                                </div>
                              </v-col>

                              <v-col cols="6" class="py-2">
                                <div class="tituloInfo">Data emitida</div>

                                <div :class="entradaSelecionada.historicoEntradaItem.dataEmissao ? 'descricaoInfo' : 'textoVazio'">
                                  {{ formatarDataBancoTipoPadrao(entradaSelecionada.historicoEntradaItem.dataEmissao) }}
                                </div>
                              </v-col>

                              <v-col cols="6" class="py-2">
                                <div class="tituloInfo">Data entrada</div>

                                <div :class="entradaSelecionada.dispensa.dataDispensa ? 'descricaoInfo' : 'textoVazio'">
                                  {{ formatarDataBancoTipoPadrao(entradaSelecionada.dispensa.dataDispensa) }}
                                </div>
                              </v-col>

                              <v-col cols="6" class="py-2">
                                <div class="tituloInfo">Total dispensado</div>

                                <div :class="entradaSelecionada.dispensa.quantidadeDispensa ? 'descricaoInfo' : 'textoVazio'">
                                  {{ formataVazio(entradaSelecionada.dispensa.quantidadeDispensa) }}
                                </div>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col v-if="entradaSelecionada.itensEntradaDispensa.length > 0" cols="12">
                                <DataTable :tableTitle="'Produtos Recebidos'" :tableHeader="headerItensNotaEntrada" :tableRows="entradaSelecionada.itensEntradaDispensa"></DataTable>
                              </v-col>

                              <v-col v-else cols="12">
                                <v-card-text>
                                  <span class="text-subtitle-1 font-weight-light">Não é possível de exibir os produtos recebidos, pois, não há dados para exibir.</span>
                                </v-card-text>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-col>

              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de exibir os dados de entradas, pois, não há dados para exibir.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-- #endregion -->
    </FormRelatorio>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import validations from "@/utils/validation";
import Alertas from "@/components/Alertas.vue";
import AlertaSnackbar from "@/components/AlertaSnackbar.vue";
import Loading from "@/components/Loading.vue";
import DataTable from "@/components/DataTable2.vue";
import FormRelatorio from "@/components/FormRelatorio";
import * as fs from "file-saver";
import { Workbook } from "exceljs";

export default {
  components: {
    Alertas,
    AlertaSnackbar,
    Loading,
    DataTable,
    FormRelatorio,
  },

  data: () => ({
    //#region Paginação
    page: 1,
    search: null,
    total: null,
    //#endregion

    //#region Alertas
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },
    //#endregion

    ...validations,

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    filtrosRelatorio: {
      numeroUnidade: store.state.numeroEndereco,
      dataInicio: null,
      dataInicioFormatada: null,
      dataFim: null,
      dataFimFormatada: null,
      numerosItensSistema: [],
      indicadorStatusFamilia: [],
    },

    formRelatorio: {
      modalTitleToolbar: "",
      isOpen: false,
      dataRelatorio: {
        entradasUnidade: [],
        entradaGeralItens: [],
        quantidadeTotalEntrada: null,

        dataInicio: null,
        dataFim: null,
      },
    },

    headerTodosItensRecebidos: [
      {
        text: "Produto",
        value: "nomeItem",
      },
      {
        text: "Lote",
        value: "loteItem",
      },
      {
        text: "Validade",
        value: "validadeItem",
      },
      {
        text: "Unidade de Medida",
        value: "unidadeMedida",
      },
      {
        text: "Quantidade Recebida",
        value: "quantidadeEntrada",
      },
      {
        text: "Data da entrada",
        value: "dataDispensa",
      },
    ],

    headerItensNotaEntrada: [
      {
        text: "N°",
        value: "numeroItemDispensa",
      },
      {
        text: "Produto",
        value: "nomeItem",
      },
      {
        text: "Lote",
        value: "loteItem",
      },
      {
        text: "Validade",
        value: "validadeItem",
      },
      {
        text: "Unidade de Medida",
        value: "unidadeMedida",
      },
      {
        text: "Quantidade Recebida",
        value: "quantidadeEntrada",
      },
    ],

    menuDe: false,
    menuAte: false,
    loading: false,
    tudoValido: false,
    botaoGerarRelatorio: false,

    listaDeProdutos: [],
    listaDeFamilias: [
      { value: 1, text: "Medicações" },
      { value: 2, text: "Materiais" },
      { value: 3, text: "Psicotrópicos" },
      { value: 4, text: "Saneantes" },
      { value: 5, text: "Cosméticos" },
      { value: 6, text: "Nutrição" },
      { value: 7, text: "Antimicrobianos" },
      { value: 8, text: "Amostra Grátis"},
      { value: 9, text: "Maleta de Emergência"},
      { value: 10, text: "Doação"},
      { value: 11, text: "Teste Rápido"},
      { value: 12, text: "USO INTERNO"}
    ],
  }),

  created() {
    this.inicializar();
  },

  watch: {
    tudoValido() {
      this.botaoGerarRelatorio = !this.tudoValido;
    },
  },

  methods: {
    //#region LISTAGENS
    async inicializar() {
      try {
        await this.listarProdutos();
      } catch (error) {
        console.log(error);
      }
    },

    async listarProdutos() {
      try {
        const response = await axios.put("produtosNotas", { numeroUnidade: store.state.numeroEndereco }, this.config);

        this.listaDeProdutos = response.data.map((produtoSelecionado) => {
          return {
            value: produtoSelecionado.numeroItemSistema,
            text: produtoSelecionado.nomeItemSistema,
            numeroItemSistema: produtoSelecionado.numeroItemSistema,
            nomeItemSistema: produtoSelecionado.nomeItemSistema,
            descricaoItemSistema: produtoSelecionado.descricaoItemSistema,
            statusItemSistema: produtoSelecionado.statusItemSistema,
          };
        });
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },
    //#endregion

    //#region EVENTOS REQUISIÇÃO
    async gerarRelatorio() {
      this.loading = true;
      try {
        this.alerta.tipo = "";

        const dadosRelatorio = await axios.put("relatorioDeEntradas", this.filtrosRelatorio, this.config);
        this.modalRelatorio(dadosRelatorio.data);
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
        this.loading = false;
      }
    },
    //#endregion

    //#region FUNÇÕES MODAL
    async modalRelatorio(dados) {
      try {
        this.formRelatorio.dataRelatorio.entradasUnidade = dados.entradasUnidade;
        this.formRelatorio.dataRelatorio.entradaGeralItens = dados.entradaGeralItens;
        this.formRelatorio.dataRelatorio.quantidadeTotalEntrada = dados.quantidadeTotalEntrada;

        this.formRelatorio.dataRelatorio.dataInicio = this.filtrosRelatorio.dataInicioFormatada ? this.filtrosRelatorio.dataInicioFormatada : null;
        this.formRelatorio.dataRelatorio.dataFim = this.filtrosRelatorio.dataFimFormatada ? this.filtrosRelatorio.dataFimFormatada : this.filtrosRelatorio.dataInicioFormatada ? this.formatarData(new Date().toISOString().substr(0, 10)) : null;
      } catch (error) {
        console.log(error);
      } finally {
        this.formRelatorio.modalTitleToolbar = "Relatório de Entradas";
        this.formRelatorio.isOpen = true;
        this.loading = false;
      }
    },
    //#endregion

    //#region FUNÇÕES NORMAIS
    removeItem(item) {
      const index = this.filtrosRelatorio.numerosItensSistema.indexOf(item.value);
      if (index >= 0) this.filtrosRelatorio.numerosItensSistema.splice(index, 1);
    },

    removeStatus(item) {
      const index = this.filtrosRelatorio.indicadorStatusFamilia.indexOf(item.value);
      if (index >= 0) this.filtrosRelatorio.indicadorStatusFamilia.splice(index, 1);
    },

    fecharFormRelatorio() {
      this.filtrosRelatorio.numerosItensSistema = [];
      this.filtrosRelatorio.indicadorStatusFamilia = [];

      this.filtrosRelatorio.dataInicio = null;
      this.filtrosRelatorio.dataInicioFormatada = null;
      this.filtrosRelatorio.dataFim = null;
      this.filtrosRelatorio.dataFimFormatada = null;

      this.formRelatorio.dataRelatorio.entradasUnidade = [];
      this.formRelatorio.dataRelatorio.entradaGeralItens = [];
      this.formRelatorio.dataRelatorio.quantidadeTotalEntrada = null;

      this.formRelatorio.dataRelatorio.dataInicio = null;
      this.formRelatorio.dataRelatorio.dataFim = null;

      this.formRelatorio.isOpen = false;
    },
    //#endregion

    //#region FORMATADORES
    formataVazio(item) {
      if (item) {
        return item;
      } else {
        return "Não informado";
      }
    },

    formatarDataTipoBanco(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);

        return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
      } else {
        return null;
      }
    },

    formatarDataBancoTipoPadrao(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);

        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
      } else {
        return null;
      }
    },

    analizarData(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatarData(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    //#endregion

    //#region EXCEL
    async gerarExcel(dados) {
      this.loading = true;

      const workbook = new Workbook();

      //#region STYLES
      var borderStyles = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      const fontStyleTituloInfo = { name: "Arial", family: 2, size: 13, bold: true, color: { argb: "232323" } };
      const fontStyleHeaderText = { name: "Arial", family: 2, size: 10, bold: true, color: { argb: "232323" } };
      const fontStyleDescricaoInfo = { name: "Arial", family: 2, size: 12, color: { argb: "232323" } };
      const fontStyleSemInfo = { name: "Arial", family: 2, size: 12, color: { argb: "9E9E9E" } };
      const alignmentNormalStyle = { vertical: "middle", horizontal: "left", wrapText: true };
      const alignmentCenterStyle = { vertical: "middle", horizontal: "center", wrapText: true };
      const mainFillColorStyle = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
      const fillColorStyle = { type: "pattern", pattern: "solid", fgColor: { argb: "ecf0f1" } };
      //#endregion

      //#region TODOS OS PRODUTOS RECEBIDOS
      let posicaoLinhaProdutos = 1;
      var worksheetProdutos = workbook.addWorksheet("Todos Produtos", {
        views: [{ showGridLines: false }],
      });

      worksheetProdutos.columns = [
        { key: "col1", width: 30 },
        { key: "col2", width: 16 },
        { key: "col3", width: 16 },
        { key: "col4", width: 16 },
        { key: "col5", width: 16 },
        { key: "col6", width: 16 },
      ];

      worksheetProdutos.mergeCells("A" + posicaoLinhaProdutos + ":F" + posicaoLinhaProdutos);
      worksheetProdutos.getCell("A" + posicaoLinhaProdutos).value = "Todos produtos recebidos | Total: " + dados.quantidadeTotalEntrada;
      worksheetProdutos.getCell("A" + posicaoLinhaProdutos).font = fontStyleTituloInfo;
      worksheetProdutos.getCell("A" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
      worksheetProdutos.getCell("A" + posicaoLinhaProdutos).fill = mainFillColorStyle;
      worksheetProdutos.getRow(posicaoLinhaProdutos).height = 30;
      posicaoLinhaProdutos++;

      if (dados.entradaGeralItens.length > 0) {
        worksheetProdutos.getRow(posicaoLinhaProdutos).height = 24;
        worksheetProdutos.getCell("A" + posicaoLinhaProdutos).value = "Produto";
        worksheetProdutos.getCell("A" + posicaoLinhaProdutos).font = fontStyleHeaderText;
        worksheetProdutos.getCell("A" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
        worksheetProdutos.getCell("A" + posicaoLinhaProdutos).fill = fillColorStyle;

        worksheetProdutos.getCell("B" + posicaoLinhaProdutos).value = "Lote";
        worksheetProdutos.getCell("B" + posicaoLinhaProdutos).font = fontStyleHeaderText;
        worksheetProdutos.getCell("B" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
        worksheetProdutos.getCell("B" + posicaoLinhaProdutos).fill = fillColorStyle;

        worksheetProdutos.getCell("C" + posicaoLinhaProdutos).value = "Validade";
        worksheetProdutos.getCell("C" + posicaoLinhaProdutos).font = fontStyleHeaderText;
        worksheetProdutos.getCell("C" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
        worksheetProdutos.getCell("C" + posicaoLinhaProdutos).fill = fillColorStyle;

        worksheetProdutos.getCell("D" + posicaoLinhaProdutos).value = "Unidade de Medida";
        worksheetProdutos.getCell("D" + posicaoLinhaProdutos).font = fontStyleHeaderText;
        worksheetProdutos.getCell("D" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
        worksheetProdutos.getCell("D" + posicaoLinhaProdutos).fill = fillColorStyle;

        worksheetProdutos.getCell("E" + posicaoLinhaProdutos).value = "Quantidade Recebida";
        worksheetProdutos.getCell("E" + posicaoLinhaProdutos).font = fontStyleHeaderText;
        worksheetProdutos.getCell("E" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
        worksheetProdutos.getCell("E" + posicaoLinhaProdutos).fill = fillColorStyle;

        worksheetProdutos.getCell("F" + posicaoLinhaProdutos).value = "Data da entrada";
        worksheetProdutos.getCell("F" + posicaoLinhaProdutos).font = fontStyleHeaderText;
        worksheetProdutos.getCell("F" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
        worksheetProdutos.getCell("F" + posicaoLinhaProdutos).fill = fillColorStyle;
        posicaoLinhaProdutos++;

        dados.entradaGeralItens.map((produtoSelecionado) => {
          worksheetProdutos.getCell("A" + posicaoLinhaProdutos).value = produtoSelecionado.nomeItem;
          worksheetProdutos.getCell("A" + posicaoLinhaProdutos).font = fontStyleDescricaoInfo;
          worksheetProdutos.getCell("A" + posicaoLinhaProdutos).alignment = alignmentNormalStyle;

          worksheetProdutos.getCell("B" + posicaoLinhaProdutos).value = produtoSelecionado.loteItem;
          worksheetProdutos.getCell("B" + posicaoLinhaProdutos).font = fontStyleDescricaoInfo;
          worksheetProdutos.getCell("B" + posicaoLinhaProdutos).alignment = alignmentNormalStyle;

          worksheetProdutos.getCell("C" + posicaoLinhaProdutos).value = produtoSelecionado.validadeItem;
          worksheetProdutos.getCell("C" + posicaoLinhaProdutos).font = fontStyleDescricaoInfo;
          worksheetProdutos.getCell("C" + posicaoLinhaProdutos).alignment = alignmentNormalStyle;

          worksheetProdutos.getCell("D" + posicaoLinhaProdutos).value = produtoSelecionado.unidadeMedida ? produtoSelecionado.unidadeMedida : "Não informado";
          worksheetProdutos.getCell("D" + posicaoLinhaProdutos).font = produtoSelecionado.unidadeMedida ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheetProdutos.getCell("D" + posicaoLinhaProdutos).alignment = alignmentNormalStyle;

          worksheetProdutos.getCell("E" + posicaoLinhaProdutos).value = produtoSelecionado.quantidadeEntrada;
          worksheetProdutos.getCell("E" + posicaoLinhaProdutos).font = fontStyleDescricaoInfo;
          worksheetProdutos.getCell("E" + posicaoLinhaProdutos).alignment = alignmentNormalStyle;

          worksheetProdutos.getCell("F" + posicaoLinhaProdutos).value = this.formatarDataBancoTipoPadrao(produtoSelecionado.dataDispensa);
          worksheetProdutos.getCell("F" + posicaoLinhaProdutos).font = fontStyleDescricaoInfo;
          worksheetProdutos.getCell("F" + posicaoLinhaProdutos).alignment = alignmentNormalStyle;

          const nomeItemLength = produtoSelecionado.nomeItem ? produtoSelecionado.nomeItem.length : 0;

          const numLines = Math.ceil(nomeItemLength / 14);
          worksheetProdutos.getRow(posicaoLinhaProdutos).height = numLines * 15;
          posicaoLinhaProdutos++;
        });
      } else {
        worksheetProdutos.mergeCells("A" + posicaoLinhaProdutos + ":F" + posicaoLinhaProdutos);
        worksheetProdutos.getCell("A" + posicaoLinhaProdutos).value = "Não é possível de exibir todos os produtos recebidos, pois, não há dados para exibir.";
        worksheetProdutos.getCell("A" + posicaoLinhaProdutos).font = fontStyleDescricaoInfo;
        worksheetProdutos.getCell("A" + posicaoLinhaProdutos).alignment = alignmentCenterStyle;
        posicaoLinhaProdutos++;
      }

      worksheetProdutos.eachRow({ includeEmpty: true }, function(row) {
        row.eachCell({ includeEmpty: true }, function(cell) {
          cell.border = borderStyles;
        });
      });
      //#endregion

      //#region NOTAS ENTRADAS
      let posicaoLinhaNotas = 1;
      var worksheetNotas = workbook.addWorksheet("Notas Recebidas", {
        views: [{ showGridLines: false }],
      });

      worksheetNotas.columns = [
        { key: "col1", width: 20 },
        { key: "col2", width: 20 },
        { key: "col3", width: 20 },
        { key: "col4", width: 20 },
        { key: "col5", width: 20 },
        { key: "col6", width: 20 },
      ];

      worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
      worksheetNotas.getCell("A" + posicaoLinhaNotas).value = dados.dataInicio ? "Notas recebidas de " + dados.dataInicio + " até " + dados.dataFim : "Notas recebidas";
      worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleTituloInfo;
      worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
      worksheetNotas.getCell("A" + posicaoLinhaNotas).fill = mainFillColorStyle;
      worksheetNotas.getRow(posicaoLinhaNotas).height = 30;
      posicaoLinhaNotas++;

      if (dados.entradasUnidade.length > 0) {
        dados.entradasUnidade.map((entradaSelecionada, indexNota) => {
          worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).value = "Nota: N° " + entradaSelecionada.dispensa.numeroDispensa + " - " + entradaSelecionada.historicoEntradaItem.descricaoNumeroNota + " | Total: " + entradaSelecionada.dispensa.quantidadeDispensa;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleTituloInfo;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).fill = mainFillColorStyle;
          worksheetNotas.getRow(posicaoLinhaNotas).height = 30;
          posicaoLinhaNotas++;

          worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":C" + posicaoLinhaNotas);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).value = "Número nota";
          worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleTituloInfo;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentNormalStyle;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).fill = fillColorStyle;

          worksheetNotas.mergeCells("D" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
          worksheetNotas.getCell("D" + posicaoLinhaNotas).value = "Data emitida";
          worksheetNotas.getCell("D" + posicaoLinhaNotas).font = fontStyleTituloInfo;
          worksheetNotas.getCell("D" + posicaoLinhaNotas).alignment = alignmentNormalStyle;
          worksheetNotas.getCell("D" + posicaoLinhaNotas).fill = fillColorStyle;
          worksheetNotas.getRow(posicaoLinhaNotas).height = 20;
          posicaoLinhaNotas++;

          worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":C" + posicaoLinhaNotas);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).value = this.formataVazio(entradaSelecionada.historicoEntradaItem.descricaoNumeroNota);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).font = entradaSelecionada.historicoEntradaItem.descricaoNumeroNota ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

          worksheetNotas.mergeCells("D" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
          worksheetNotas.getCell("D" + posicaoLinhaNotas).value = this.formatarDataBancoTipoPadrao(entradaSelecionada.historicoEntradaItem.dataEmissao);
          worksheetNotas.getCell("D" + posicaoLinhaNotas).font = entradaSelecionada.historicoEntradaItem.dataEmissao ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheetNotas.getCell("D" + posicaoLinhaNotas).alignment = alignmentNormalStyle;
          worksheetNotas.getRow(posicaoLinhaNotas).height = 20;
          posicaoLinhaNotas++;

          worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":C" + posicaoLinhaNotas);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).value = "Data entrada";
          worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleTituloInfo;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentNormalStyle;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).fill = fillColorStyle;

          worksheetNotas.mergeCells("D" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
          worksheetNotas.getCell("D" + posicaoLinhaNotas).value = "Total dispensado";
          worksheetNotas.getCell("D" + posicaoLinhaNotas).font = fontStyleTituloInfo;
          worksheetNotas.getCell("D" + posicaoLinhaNotas).alignment = alignmentNormalStyle;
          worksheetNotas.getCell("D" + posicaoLinhaNotas).fill = fillColorStyle;
          worksheetNotas.getRow(posicaoLinhaNotas).height = 20;
          posicaoLinhaNotas++;

          worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":C" + posicaoLinhaNotas);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).value = this.formatarDataBancoTipoPadrao(entradaSelecionada.dispensa.dataDispensa);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).font = entradaSelecionada.dispensa.dataDispensa ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

          worksheetNotas.mergeCells("D" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
          worksheetNotas.getCell("D" + posicaoLinhaNotas).value = this.formataVazio(entradaSelecionada.dispensa.quantidadeDispensa);
          worksheetNotas.getCell("D" + posicaoLinhaNotas).font = entradaSelecionada.dispensa.quantidadeDispensa ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheetNotas.getCell("D" + posicaoLinhaNotas).alignment = alignmentNormalStyle;
          worksheetNotas.getRow(posicaoLinhaNotas).height = 20;
          posicaoLinhaNotas++;

          worksheetNotas.getRow(posicaoLinhaNotas).height = 24;
          worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
          worksheetNotas.getCell("A" + posicaoLinhaNotas).value = "Produtos Recebidos";
          worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleTituloInfo;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
          worksheetNotas.getCell("A" + posicaoLinhaNotas).fill = fillColorStyle;
          posicaoLinhaNotas++;

          //#region PRODUTOS RECEBIDOS
          if (entradaSelecionada.itensEntradaDispensa.length > 0) {
            worksheetNotas.getRow(posicaoLinhaNotas).height = 24;
            worksheetNotas.getCell("A" + posicaoLinhaNotas).value = "N°";
            worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleHeaderText;
            worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
            worksheetNotas.getCell("A" + posicaoLinhaNotas).fill = fillColorStyle;

            worksheetNotas.getCell("B" + posicaoLinhaNotas).value = "Produto";
            worksheetNotas.getCell("B" + posicaoLinhaNotas).font = fontStyleHeaderText;
            worksheetNotas.getCell("B" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
            worksheetNotas.getCell("B" + posicaoLinhaNotas).fill = fillColorStyle;

            worksheetNotas.getCell("C" + posicaoLinhaNotas).value = "Lote";
            worksheetNotas.getCell("C" + posicaoLinhaNotas).font = fontStyleHeaderText;
            worksheetNotas.getCell("C" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
            worksheetNotas.getCell("C" + posicaoLinhaNotas).fill = fillColorStyle;

            worksheetNotas.getCell("D" + posicaoLinhaNotas).value = "Validade";
            worksheetNotas.getCell("D" + posicaoLinhaNotas).font = fontStyleHeaderText;
            worksheetNotas.getCell("D" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
            worksheetNotas.getCell("D" + posicaoLinhaNotas).fill = fillColorStyle;

            worksheetNotas.getCell("E" + posicaoLinhaNotas).value = "Unidade de Medida";
            worksheetNotas.getCell("E" + posicaoLinhaNotas).font = fontStyleHeaderText;
            worksheetNotas.getCell("E" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
            worksheetNotas.getCell("E" + posicaoLinhaNotas).fill = fillColorStyle;

            worksheetNotas.getCell("F" + posicaoLinhaNotas).value = "Quantidade Recebida";
            worksheetNotas.getCell("F" + posicaoLinhaNotas).font = fontStyleHeaderText;
            worksheetNotas.getCell("F" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
            worksheetNotas.getCell("F" + posicaoLinhaNotas).fill = fillColorStyle;
            posicaoLinhaNotas++;

            entradaSelecionada.itensEntradaDispensa.map((produtoSelecionado) => {
              worksheetNotas.getCell("A" + posicaoLinhaNotas).value = produtoSelecionado.numeroItemDispensa;
              worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleDescricaoInfo;
              worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

              worksheetNotas.getCell("B" + posicaoLinhaNotas).value = produtoSelecionado.nomeItem;
              worksheetNotas.getCell("B" + posicaoLinhaNotas).font = fontStyleDescricaoInfo;
              worksheetNotas.getCell("B" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

              worksheetNotas.getCell("C" + posicaoLinhaNotas).value = produtoSelecionado.loteItem;
              worksheetNotas.getCell("C" + posicaoLinhaNotas).font = fontStyleDescricaoInfo;
              worksheetNotas.getCell("C" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

              worksheetNotas.getCell("D" + posicaoLinhaNotas).value = produtoSelecionado.validadeItem;
              worksheetNotas.getCell("D" + posicaoLinhaNotas).font = fontStyleDescricaoInfo;
              worksheetNotas.getCell("D" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

              worksheetNotas.getCell("E" + posicaoLinhaNotas).value = produtoSelecionado.unidadeMedida ? produtoSelecionado.unidadeMedida : "Não informado";
              worksheetNotas.getCell("E" + posicaoLinhaNotas).font = produtoSelecionado.unidadeMedida ? fontStyleDescricaoInfo : fontStyleSemInfo;
              worksheetNotas.getCell("E" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

              worksheetNotas.getCell("F" + posicaoLinhaNotas).value = produtoSelecionado.quantidadeEntrada;
              worksheetNotas.getCell("F" + posicaoLinhaNotas).font = fontStyleDescricaoInfo;
              worksheetNotas.getCell("F" + posicaoLinhaNotas).alignment = alignmentNormalStyle;

              const nomeItemLength = produtoSelecionado.nomeItem ? produtoSelecionado.nomeItem.length : 0;

              const numLines = Math.ceil(nomeItemLength / 14);
              worksheetNotas.getRow(posicaoLinhaNotas).height = numLines * 18;
              posicaoLinhaNotas++;
            });
          } else {
            worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
            worksheetNotas.getCell("A" + posicaoLinhaNotas).value = "Não é possível de exibir os produtos recebidos, pois, não há dados para exibir.";
            worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleDescricaoInfo;
            worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
            posicaoLinhaNotas++;
          }
          posicaoLinhaNotas++;
          posicaoLinhaNotas++;
          posicaoLinhaNotas++;
          //#endregion

          if (indexNota < dados.entradasUnidade.length - 1) {
            worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
            worksheetNotas.getCell("A" + posicaoLinhaNotas).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "232323" } };
            worksheetNotas.getRow(posicaoLinhaNotas).height = 2;
            posicaoLinhaNotas++;
            posicaoLinhaNotas++;
          }
        });
      } else {
        worksheetNotas.mergeCells("A" + posicaoLinhaNotas + ":F" + posicaoLinhaNotas);
        worksheetNotas.getCell("A" + posicaoLinhaNotas).value = "Não é possível de exibir os dados de entradas, pois, não há dados para exibir.";
        worksheetNotas.getCell("A" + posicaoLinhaNotas).font = fontStyleDescricaoInfo;
        worksheetNotas.getCell("A" + posicaoLinhaNotas).alignment = alignmentCenterStyle;
        posicaoLinhaNotas++;
      }

      worksheetNotas.eachRow({ includeEmpty: true }, function(row) {
        row.eachCell({ includeEmpty: true }, function(cell) {
          cell.border = borderStyles;
        });
      });
      //#endregion

      const nomeArquivo = dados.dataInicio ? "Relatório de Entradas - De " + dados.dataInicio + " até " + dados.dataFim : "Relatório de Entradas";

      workbook.xlsx.writeBuffer().then(function(data) {
        var blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(blob, nomeArquivo + ".xlsx");
      });

      this.loading = false;
    },
    //#endregion
  },
};
</script>

<style>
.tituloInfo {
  font-size: smaller;
  font-weight: 500;
  color: rgba(85, 85, 85, 0.7);
}
.descricaoInfo {
  font-size: larger;
  font-weight: 400;
  color: rgb(35, 35, 35);
}
.titulo {
  font-size: large;
  font-weight: 500;
  color: #212121;
}
.textoVazio {
  color: rgba(0, 0, 0, 0.3);
}
</style>
